export default __webpack_public_path__ + "static/media/ar_06_07_image.49718817.jpg";